import { Modal } from "common/Modal"
import { Fragment, useEffect, useState } from "react"
import { formatDate } from "utils/funcs"
import classNames from "classnames"
import UserService from "services/user.service"
import { useNotifications } from "hooks/useNotification"
import { useSelector } from "react-redux"
import CopyText from "common/CopyText"
import { formatPhone } from "pages/Contacts"
import axios from "axios"
import { GHL_WEBHOOK_URL } from "utils/apiConfig"

const service = new UserService()

export const CampaignModal = ({
  data,
  filteredData,
  setShowScreening,
  showModal,
  fetchData,
  setData,
  setShowModal,
}) => {
  const [index, setIndex] = useState(0)
  const [open, setOpen] = useState(false)
  const [calling, setCalling] = useState(false)
  const [hoverRating, setHoverRating] = useState(0)
  const [rejectModal, setRejectModal] = useState(false)
  const [updateField, setUpdateField] = useState({
    candidateInterest: "",
    notes: "",
    callNotes: "",
    result: "",
  })

  useEffect(() => {
    setUpdateField((prev) => ({
      ...prev,
      callNotes: filteredData[index]?.screening?.callNotes || "",
    }))
  }, [index, filteredData])

  const { user } = useSelector((state: any) => state.user)

  const { errorMessage, successMessage } = useNotifications()

  const handleNext = (decrement?: string) => {
    if (decrement) {
      setIndex((prev) => prev - 1)
    }
    if (index < filteredData.length - 1) {
      setIndex((prev) => prev + 1)
    }

    if (index === filteredData?.length - 1) {
      setShowModal(false)
      setIndex(0)
      fetchData()
    }
  }

  const updateData = (newData) => {
    setShowScreening(false)
    const shallowCopy = [...data]
    const updatedData = shallowCopy.map((item) => {
      if (item._id === filteredData[index]._id) {
        return newData
      }
      return item
    })
    setData(updatedData)
    setTimeout(() => {
      setShowScreening(true)
    }, 1000)
  }

  const handleUpdateFields = (e) => {
    e.preventDefault()

    const payload = {
      userId: user?._id,
      email: user?.email,
      fullName: user?.fullname,
      ...updateField,
    }

    if (!updateField.result) {
      errorMessage("Please select disposition")
      return
    } else if (
      updateField.result === "Accepted" &&
      !updateField.candidateInterest
    ) {
      errorMessage("Please select rating")
      return
    }

    setCalling(true)
    service
      .updateAttempts(filteredData[index]._id, payload)
      .then((resp) => {
        if (resp.data.success) {
          handleNext("decrement")
          successMessage("Candidate updated successfully")
          setUpdateField({
            candidateInterest: "",
            result: "",
            notes: "",
            callNotes: "",
          })
          updateData(resp.data.data)
        }
        setCalling(false)
      })
      .catch((error) => console.error(error))
  }

  const handleClickNoAnswer = () => {
    setCalling(true)
    service
      .updateAttempts(filteredData[index]._id, {
        callNotes: updateField.callNotes,
        result: "No answer",
        userId: user?._id,
        email: user?.email,
        fullName: user?.fullname,
      })
      .then((resp) => {
        handleNext()
        setCalling(false)
        setUpdateField({
          ...updateField,
          callNotes: "",
        })
        updateData(resp.data.data)
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const handleFollowup = () => {
    setCalling(true)
    service
      .updateAttempts(filteredData[index]._id, {
        callNotes: updateField.callNotes,
        result: "Follow up",
        userId: user?._id,
        email: user?.email,
        fullName: user?.fullname,
      })
      .then((resp) => {
        handleNext()
        setCalling(false)
        updateData(resp.data.data)
        setUpdateField({
          ...updateField,
          callNotes: "",
        })
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const handleAiFirst = () => {
    setCalling(true)
    service
      .updateAiFirst(filteredData[index]._id, { aiFirst: "Yes" })
      .then((resp) => {
        if (resp.data.success) {
          successMessage("Candidate sent to AI successfully")
          handleNext()
          updateData(resp.data.updated)
          setCalling(false)
        } else {
          errorMessage("Failed to send candidate to AI")
        }
      })

    if (GHL_WEBHOOK_URL) {
      axios
        .post(GHL_WEBHOOK_URL, {
          "Full Name": filteredData[index]?.full_name,
          Email: filteredData[index]?.email,
          "Phone Number": filteredData[index]?.phone,
          "Dealer Name": filteredData[index]?.candidate?.leader_name,
        })
        .then((response) => {
          successMessage(response.data.message)
        })
        .catch((error) => {
          console.error("Failed to trigger webhook", error)
        })
    } else {
      console.error("GHL webhook URL is not configured.")
    }
  }

  const handleStarHover = (starValue) => {
    setHoverRating(starValue)
  }

  const handleMouseLeave = () => {
    setHoverRating(0)
  }

  return (
    <Fragment>
      <Modal
        showModal={showModal}
        setShowModal={setShowModal}
        width="w-full md:max-w-6xl overflow-auto"
        title={`Preview Dialer - Caller: ${user?.fullname} (${index + 1} of ${
          filteredData.length
        })`}
        onClick={() => setIndex(0)}
        onClose={() => setIndex(0)}
      >
        <div id="dialer-screen">
          {/* <header className="flex items-center justify-between p-4 text-white bg-gray-800">
          <h1 className="text-xl font-bold">Preview Dialer</h1>
        </header> */}
          {/* 
        <p className="px-2 pb-4 text-lg font-semibold">
          
        </p> */}
          <main className="grid grid-cols-1 gap-8 px-3 pb-8 md:grid-cols-2">
            <div className="flex flex-col space-y-6">
              <div className="flex items-center justify-between w-full gap-2">
                {index > 0 && (
                  <button
                    type="button"
                    onClick={() => setIndex((prev) => prev - 1)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="w-6 h-6"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18"
                      />
                    </svg>
                  </button>
                )}
                <h2 className="pb-2 text-2xl font-bold text-center border-b">
                  Candidate Details
                </h2>
                <div>
                  {index < filteredData.length - 1 && (
                    <button
                      type="button"
                      onClick={() => setIndex((prev) => prev + 1)}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="w-6 h-6"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"
                        />
                      </svg>
                    </button>
                  )}
                </div>
              </div>

              <div id="candidate-info" className="grid grid-cols-2 space-y-4">
                <div>
                  <label className="field-label">
                    Name
                  </label>
                  <p id="candidate-name" className="text-lg font-semibold">
                    {filteredData[index]?.full_name}
                  </p>
                </div>
                <div>
                  <label className="field-label">
                    Applied Date
                  </label>
                  <p id="candidate-applied-date" className="text-lg">
                    {formatDate(filteredData[index]?.createdAt)}
                  </p>
                </div>
                <div>
                  <label className="field-label">
                    Company
                  </label>
                  <p id="candidate-company" className="text-lg">
                    {filteredData[index]?.company?.title}
                  </p>
                </div>
                <div>
                  <label className="field-label">
                    Location
                  </label>
                  <p id="candidate-location" className="text-lg">
                    {filteredData[index]?.address.city}
                  </p>
                </div>
                <div>
                  <label className="field-label">
                    Email
                  </label>
                  <div id="candidate-email" className="text-lg break-all">
                    <CopyText
                      text={filteredData[index]?.email}
                      copyText={filteredData[index]?.email}
                    />
                  </div>
                </div>
                <div>
                  <label className="field-label">
                    Phone Number
                  </label>
                  <div id="candidate-phone" className="font-mono text-lg">
                    <CopyText
                      text={formatPhone(filteredData[index]?.phone)}
                      copyText={filteredData[index]?.phone}
                    />
                  </div>
                </div>
                <div className="col-span-2">
                  <label
                    htmlFor="call-notes"
                    className="text-sm font-medium text-gray-500"
                  >
                    Call Notes
                  </label>
                  <textarea
                    id="call-notes"
                    name="call-notes"
                    rows={3}
                    onChange={(e) =>
                      setUpdateField({
                        ...updateField,
                        callNotes: e.target.value,
                      })
                    }
                    value={updateField.callNotes}
                    className="w-full mt-1 border-gray-300 rounded-lg shadow-sm focus:border-red-500 focus:ring-red-500"
                  />
                </div>
              </div>

              <div className="space-y-4">
                <div className="flex items-center justify-between p-3 text-yellow-800 bg-yellow-100 rounded-lg">
                  <span className="font-semibold">Contact Attempts</span>
                  <span id="attempt-count" className="text-lg font-bold">
                    {filteredData[index]?.screening?.contactAttempt ?? 0}
                  </span>
                </div>
                {/* <button
                id="copy-number-btn"
                type="button"
                onClick={() =>
                  navigator.clipboard.writeText(filteredData[index]?.phone)
                }
                className="flex items-center justify-center w-full gap-2 px-4 py-3 font-bold text-white transition-all duration-200 bg-red-600 rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path d="M8 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z" />
                  <path d="M6 3a2 2 0 00-2 2v11a2 2 0 002 2h8a2 2 0 002-2V5a2 2 0 00-2-2 3 3 0 01-3 3H9a3 3 0 01-3-3z" />
                </svg>
                Copy Phone Number
              </button> */}
                <p
                  id="copy-feedback"
                  className="h-4 text-sm text-center text-green-600"
                ></p>
              </div>
            </div>

            <div className="flex flex-col space-y-6">
              <h2 className="pb-2 text-2xl font-bold border-b">Log Attempt</h2>

              <div className="grid grid-cols-2 gap-4">
                <button
                  id="no-answer-btn"
                  type="button"
                  disabled={calling}
                  onClick={handleClickNoAnswer}
                  className="w-full px-4 py-3 font-bold text-gray-700 transition-all duration-200 bg-gray-200 rounded-lg disabled:bg-opacity-40 hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400"
                >
                  {calling ? "Please wait..." : "No Answer"}
                </button>
                <button
                  id="contacted-btn"
                  type="button"
                  onClick={() => setOpen((prev) => !prev)}
                  className="w-full px-4 py-3 font-bold text-white transition-all duration-200 bg-green-500 rounded-lg hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                >
                  Contacted
                </button>
                <button
                  type="button"
                  onClick={handleAiFirst}
                  className="w-full px-4 py-3 font-bold text-white transition-all duration-200 bg-blue-500 rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                >
                  {calling ? "Please wait..." : "Send to AI"}
                </button>
              </div>

              <div
                id="contacted-form"
                className={classNames(
                  "pt-6 space-y-6 transition transform duration-100 overflow-hidden border-t ",
                  {
                    "opacity-1": open,
                    "max-h-0 opacity-0": !open,
                  }
                )}
              >
                <div>
                  <label className="text-base font-medium text-gray-900">
                    Disposition
                  </label>
                  <fieldset className="mt-2">
                    <div className="flex items-center space-x-4">
                      <div className="flex items-center">
                        <input
                          id="disposition-accept"
                          name="disposition"
                          onChange={() =>
                            setUpdateField({
                              ...updateField,
                              result: "Accepted",
                            })
                          }
                          type="radio"
                          checked={updateField.result === "Accepted"}
                          value="Accepted"
                          className="w-4 h-4 text-red-600 border-gray-300 focus:ring-red-500"
                        />
                        <label
                          htmlFor="disposition-accept"
                          className="block ml-2 text-sm font-medium text-gray-700"
                        >
                          Accept
                        </label>
                      </div>
                      <div className="flex items-center">
                        <input
                          id="disposition-reject"
                          name="disposition"
                          onChange={() => {
                            setUpdateField({
                              ...updateField,
                              result: "Rejected",
                            })
                            setRejectModal(true)
                          }}
                          type="radio"
                          checked={updateField.result === "Rejected"}
                          value="Rejected"
                          className="w-4 h-4 text-red-600 border-gray-300 focus:ring-red-500"
                        />
                        <label
                          htmlFor="disposition-reject"
                          className="block ml-2 text-sm font-medium text-gray-700"
                        >
                          Reject
                        </label>
                      </div>
                    </div>
                  </fieldset>
                </div>

                {rejectModal && (
                  <div className="space-y-1.5">
                    {[
                      "No Car",
                      "Door-to-Door",
                      "Commission Only",
                      "Candidate Quality",
                      "Background Check",
                      "Other",
                    ].map((reason) => (
                      <p
                        key={reason}
                        onClick={() => {
                          setShowModal(true)
                          setUpdateField({ ...updateField, notes: reason })
                          setRejectModal(false)
                        }}
                        className="p-3 cursor-pointer hover:bg-gray-200 font-semibold rounded-lg bg-gray-100 text-gray-800"
                      >
                        {reason}
                      </p>
                    ))}
                  </div>
                )}

                <div className="flex items-center gap-8">
                  <label className="text-base font-medium text-gray-900">
                    Rating
                  </label>
                  <div className="flex justify-center">
                    {["1", "2", "3"].map((star) => (
                      <button
                        type="button"
                        key={star}
                        onClick={() =>
                          setUpdateField({
                            ...updateField,
                            candidateInterest: star,
                          })
                        }
                        onMouseEnter={() => handleStarHover(star)}
                        onMouseLeave={handleMouseLeave}
                        className="p-1 transition-transform duration-150 rounded-full focus:outline-none hover:scale-110"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          stroke="currentColor"
                          className={`w-6 h-6 transition-colors  ${
                            star <=
                            (hoverRating || updateField.candidateInterest)
                              ? "text-yellow-400 fill-current"
                              : "text-gray-600 hover:text-yellow-200"
                          }`}
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z"
                          />
                        </svg>
                      </button>
                    ))}
                  </div>
                </div>
                <div>
                  <label
                    htmlFor="screening-notes"
                    className="text-base font-medium text-gray-900"
                  >
                    Screening Notes
                  </label>
                  <textarea
                    id="screening-notes"
                    name="screening-notes"
                    value={updateField.notes}
                    onChange={(e) =>
                      setUpdateField({ ...updateField, notes: e.target.value })
                    }
                    rows={3}
                    className="w-full mt-2 border-gray-300 rounded-lg shadow-sm focus:border-red-500 focus:ring-red-500"
                  />
                </div>
                <div className="grid grid-cols-1 gap-4 mt-2 sm:grid-cols-2">
                  <button
                    id="needs-follow-up-btn"
                    type="button"
                    disabled={calling}
                    onClick={handleFollowup}
                    className="w-full px-4 py-3 font-bold text-white transition-all duration-200 rounded-lg disabled:bg-opacity-20 bg-amber-500 hover:bg-amber-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500"
                  >
                    {calling ? "Please wait..." : "Needs Follow Up"}
                  </button>
                  <button
                    id="save-btn"
                    type="button"
                    disabled={calling}
                    onClick={handleUpdateFields}
                    className="w-full px-4 py-3 font-bold text-white transition-all duration-200 bg-red-600 rounded-lg disabled:bg-opacity-20 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                  >
                    {calling ? "Saving..." : "Save & Get Next"}
                  </button>
                </div>
              </div>
            </div>
          </main>
        </div>
      </Modal>
      {/* <Modal
        showModal={rejectModal}
        setShowModal={setRejectModal}
        title="Rejection Reason"
        width="w-96 z-100"
      >
        <div className="space-y-3">
          {[
            "No Car",
            "Door-to-Door",
            "Commission Only",
            "Candidate Quality",
            "Background Check",
            "Other",
          ].map((reason) => (
            <p
              key={reason}
              onClick={() => {
                setShowModal(true)
                setUpdateField({ ...updateField, notes: reason })
                setRejectModal(false)
              }}
              className="p-3 cursor-pointer hover:bg-gray-200 font-semibold rounded-lg bg-gray-100 text-gray-800"
            >
              {reason}
            </p>
          ))}
        </div>
      </Modal> */}
    </Fragment>
  )
}
